import React, { useEffect, useState, useRef, useMemo } from "react";
import { message, notification } from 'antd';
import dayjs from 'dayjs';
import { Base64 } from "js-base64";
import { DescriptionText, FlexContainer, H1Text, H2Text, LeftBackButtonText, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import {
    addSubscriptionButtonV2ChargeById,
    getSubscriptionButtonByIdV2,
    getSecretValuesById,
    BASE_URLS,
    getHealthCheck,
    getServerEncription,
    generateClientKeyPair,
    encryptData,
    getPayPalClientToken,
    getMrn,
    action,
    getWalletOrderInfo,
    confirmWalletOrderInfo,
} from "../../api";
import { MESSAGES, SUBSCRIPTION_BUTTON_STATUSES, SWIREPAY_URL, TabNames, TANGEDCO_PG, LPG_CUSTOMER, ACQUIRER_TYPE_PAYPAL, ACQUIRER_TYPE_PAYPAL_BNY } from "../../appconstants";
import { AmountDivideByHundred } from "../../helper";
import BaseSplitPage from "../../components/splitpage";
import * as moment from "moment-timezone";
import Header from "./smallscreen/header";
import SmallScreenFooter from "../../components/footer";
import currencyFormatter from "../../utils/currencyformatter";
import getformatteddate from "../../utils/getformatteddate";
import { formatToE164 } from "../../utils/formatToE164";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import expandCategoryToPaymentTypes from "../../utils/expandCategoryToPaymentTypes";
import getRedirectionUrl from "../../utils/getRedirectionUrl";
import UpiPayment from "../../components/upipayment/UpiPayment";
import AchPayment from "../../components/achPaymentWithPlaid";
import ZipAchPayment from '../../components/zipAchWithPlaid';
import RapidAchPayment from "../../components/rapidAchWithPlaid";
import XAchPayment from "../../components/xAchWithPlaid";
import BankPayment from "../../components/bankpayment/BankPayment";
import GooglePay from "../../components/googlePay/GooglePay";
import PayPalCheckout from "../paypalCheckout";
import PaymentExpandableRows from "../../components/paymentExpandableRows";
import PaymentExpandableRowsV2 from "../../components/PaymentExpandableRowsV2";
import RecaptchaModal from "../../components/recaptcha";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";
import PayPalGooglePay from "../../components/payPalGooglePay";
import {getCountryCallingCode} from "libphonenumber-js";
import { setFormData } from "../../redux/appConfigInfo";
import { getCountryCodeAndNumber } from "../../utils/getCountryCodeAndNumber";
import SavedPaymentMethods from "../../components/SavedPaymentMethods";
import InstantAch from "../../components/InstantAch";
import SwiftAch from "../../components/SwiftAch";

const defaultAlertConfig = {
    showIcon: false, isOpen: false, hideBtn: true,
    cancel: null, header: null, body: null,
    submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
    showSubmitBtn: false, submit: null, icon: null
};

type Props = {
    history: {
        push: Function,
    },
}

const SubscriptionButtonV2 = (props: Props) => {
    const { match: { params: { subscriptionId } }, location: { pathname, search } } = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const disableButtonText = useState('The subscription is already started.');
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${subscriptionId}-tap-index`) || 0));
    const MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
    const [currentDateFormattedString, setCurrentDateFormattedString] = useState();
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [tabName, setTabName] = useState('');
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const hostName = (window && window.location && window.location.host);
    const [upiDownTime, setUpiDownTime] = useState(false);
    const accountGid = [
      'account-cdfe7eecff324778a88a2727177a1c8f'
    ];
    const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
    const dispatch = useDispatch();
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${subscriptionId}`) || undefined);
    const [ipAddress, setIpAddress] = useState('');
    const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
    const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
    const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
    const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
    const [manualPlaidPayment, setManualPlaidPayment] = useState(false);
    const [payPalClientAuth, setPayPalClientAuth] = useState('');
    const [paypalApplePayMessageModal, setPaypalApplePayMessageModal] = useState(false);
    const isPayPalApple = useRef(false);
    const isPayPalGoogle = useRef(false);
    const [paypalApplePayRecaptcha, setPaypalApplePayRecaptcha] = useState(null);
    const [cardPointGooglePayToken, setCardPointGooglePayToken] = useState(null);
    const paypalPaymentData = useRef(null);
    const [payPalClientId, setPaypalClientId] = useState('');
    const commonRecaptchaToken = useRef(null);
    const [orderDatas, setOrderData] = useState();
    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);
    const PayPalCheckoutEnable = useRef(false);

    const getPayPalAccountInfo = async (id) => {
        try {
            const payPalInfo = await getPayPalClientToken(id);
            const value = Base64.decode(payPalInfo);
            const value_json = JSON.parse(value);
            setPaypalClientId(value_json?.clientId);
            setPayPalClientAuth(payPalInfo);
            return payPalInfo;
        } catch (e) {
            console.error(e);
        }
        return null;
    }

    useEffect(() => {
        const acquirer = payment?.account?.acquirer;
        if (payment?.account?.gid && (acquirer === ACQUIRER_TYPE_PAYPAL || acquirer === ACQUIRER_TYPE_PAYPAL_BNY)) {
            getPayPalAccountInfo(payment?.account?.gid);
        }
    }, [payment]);

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
      }
    
    useEffect(() => {
    getData();
    }, []);

    useEffect(() => {
    if(updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails){
        if (updateCustomerRedux?.customerDetails?.name  && updateCustomerRedux?.customerDetails?.name !== '') {
            setPayment((prev) => ({...prev, name: updateCustomerRedux.customerDetails.name }));
        };
        if (updateCustomerRedux?.customerDetails?.email  && updateCustomerRedux?.customerDetails?.email !== '') {
            setPayment((prev) => ({...prev, email: updateCustomerRedux.customerDetails.email }));
        };
        if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
            && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1'
        ) {
            setPayment((prev) => ({...prev, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber }));
        };
        dispatch(setUpdateStatus(false));
    };
    }, [updateCustomerRedux])

    useEffect(() => {
        if (search) {
            getSubscriptionButtonDataWithSearchValue();
        } else {
            getSubscriptionButtonDataWithoutSearchValue();
        }
    }, [subscriptionId, search]);

    useEffect(() => {
        if (payment && payment.currency && payment.amount) {
            setSubmitBtnText('Pay');
            setCurrentDateFormattedString(moment.utc().tz(payment && payment.account.timezone).startOf('day').utc().format(MOMENT_FORMAT));
        }
        if (payment && payment.account && payment.account.gid) {
            if (TANGEDCO_PG === payment.account.gid) {
                setSupportedPaymentTypes(['CARD']);
            } else if (TANGEDCO_PG !== payment.account.gid) {
                // only use the recurring payment types that are also in the accounts supported payment types.
                const filteredSupportedPaymentTypes = payment?.account?.supportedRecurringPaymentTypes?.filter(recurringPaymentType => (
                    payment?.account?.supportedPaymentTypes?.some(accountSuportedPaymentType => accountSuportedPaymentType === recurringPaymentType)
                )) ?? [];
                setSupportedPaymentTypes(filteredSupportedPaymentTypes);
            }
        }

    }, [payment]);

    useEffect(() => {
        setTabName(supportedPaymentTypes && supportedPaymentTypes[selectedTab]);
    }, [selectedTab, supportedPaymentTypes]);

    useEffect(() => {
        if (payment && payment.currency && payment.currency.name !== 'INR') { setSelectedTab(0) }
    }, [selectedTab,]);

    const getSubscriptionButtonDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!params.get('ss') || !params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        setShowSpinner(true);
        try {
            const value = await getSubscriptionButtonByIdV2(subscriptionId, search);
            if (value) {
                const { redirectUri, status } = value;
                if (SUBSCRIPTION_BUTTON_STATUSES.ACTIVE === status) {
                    setTransactionSuccessModalOpen(true);
                    setTimeout(function () {
                        const uri = getRedirectionUrl(hostName);
                        if (redirectUri) {
                            window.location = `${redirectUri}?sp-subscription-button=${subscriptionId}`;
                        } else if (uri) {
                            window.location = `${uri}pay-links/subscription-button/${subscriptionId}`;
                        }
                    }, 5000);
                }
            }
        } catch (reason) {
            try {
                const value = await getSubscriptionButtonByIdV2(subscriptionId, null);
                if (value) {
                    setPayment(value);
                    dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                      value: {
                          phoneNumber: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber : '',
                          countryCode: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.countryCode : '+1',
                          name: value?.name,
                          email: value?.email,
                      } 
                    }));
                    setBankImageUrl(value.account && value.account.bankImageUrl);
                    setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
            error(reason);
        } finally {
            setShowSpinner(false);
        }
    };

    const error = reason => {
        if (!reason) return;
        // const { data: { message, messageCode }, status } = reason;
        const message = reason && reason.message;
        const messageCode = reason && reason.messageCode;
        const status = reason && reason.status;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else if (reason?.response?.data?.message) {
            setErrorMessage(reason?.response?.data?.message);
            setTransactionModalOpen(false);
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) { errorEl.scrollIntoView(); }
        }
    };

    const getGooglePayMerchantValues = async (accountGid, isTest) => {
        try {
            const values = await getSecretValuesById(accountGid, isTest);
            setGpaySecretValues(values);
        } catch (error) {
            setGpayError('Missing merchant details. Please contact support');
        }
    };

    const getSubscriptionButtonDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getSubscriptionButtonByIdV2(subscriptionId, null);
            if (value) {
                const { status, redirectUri } = value;
                if (SUBSCRIPTION_BUTTON_STATUSES.ACTIVE !== status) {
                    props.history.push(`${pathname}/expired`);
                    return;
                }
                // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
                //     const val = await getHealthCheck();
                //     if (val && val.status !== 'ACTIVE') {
                //         setUpiDownTime(true);
                //         notification.open({
                //             message: '',
                //             description: <img src={UPIIMAGE} alt="" />,
                //           });
                //     }
                //   }
                setPayment(value);
                dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                  value: {
                      phoneNumber: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber : '',
                      countryCode: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.countryCode : '+1',
                      name: value?.name,
                      email: value?.email,
                  } 
                }));
                setBankImageUrl(value.account && value.account.bankImageUrl);
                setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
                    getGooglePayMerchantValues(value && value.account && value.account.gid, value?.account?.portal?.test);
                }
                setBackButtonUrl(redirectUri || SWIREPAY_URL)
            }
        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const chargeByCard = async (data) => {
        const { customer, paymentMethod } = data;
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8", 
            ip: ipAddress,
            language: window.navigator.language, 
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height, 
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(), 
            browserUserAgent: window.navigator.userAgent
           };
        paymentMethod.userAgent = userAgent;
        await chargeById({ customer, paymentMethod });
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod } = data;
        await chargeById({ customer, paymentMethod });
    };

    const chargeByUpi = async (data) => {
        const { customer, paymentMethod } = data;
        await chargeById({ customerDetails: customer, paymentMethodDetails: paymentMethod });
    };

    const chargeByBank = async (data) => {
        const { customerGid, fundingSourceId } = data;
        const paymentMethod = {
            bank: {
                referenceId: fundingSourceId,
            },
            customerGid,
            type: "ACH"
        }
        await chargeById({ paymentMethod });
    };

    const chargeByPaypalGooglePay = async (data, localRecaptchaToken = null) => {
        try {
            paypalPaymentData.current = data;
            setTransactionModalOpen(true);
            setRecaptchaPaymentType('paypalGooglePay');
            const value = await getPayPalAccountInfo(payment?.account?.gid);
            if (value) {
                isPayPalGoogle.current = true;
                const paymentMethod = {
                    type: "WALLET",
                    subType: "GOOGLE_PAY_US",
                    googlePayUS: {
                        apiVersionMinor: data.apiVersionMinor,
                        apiVersion: data.apiVersion,
                        paymentMethodDescription: data.paymentMethodData.description,
                        paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                        paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                        paymentMethodType: data.paymentMethodData.type,
                        paymentMethodInfo: data.paymentMethodData.info
                    },
                };
                const responseEntity = await chargeById({ paymentMethod: paymentMethod }, localRecaptchaToken);
                isPayPalGoogle.current = false;
                const orderId = await getMrn(responseEntity.paymentSessionGid, responseEntity.psClientSecret);
                // Step 2: confirm PayPal order
                await window.paypal.Googlepay().confirmOrder({
                    orderId,
                    paymentMethodData: data?.paymentMethodData,
                });
                // Step 3: capture/perform final action
                await action(responseEntity.paymentSessionGid, responseEntity.psClientSecret);
                await chargeByIdSuccessActions(responseEntity);
            }
        } catch (err) {
            console.error('Google Pay Failed', err);
            message.error('GooglePay Transaction Failed');
        } finally {
            setTransactionModalOpen(false);
        }
    };

    const chargeByGooglePay = async (data) => {
        const formattedPhoneNumber = formatToE164(
            data?.paymentMethodData?.info?.billingAddress?.phoneNumber,
            data?.paymentMethodData?.info?.billingAddress?.countryCode
        );
        const customer = {
          name: data?.shippingAddress?.name || data?.paymentMethodData?.info?.billingAddress?.name || "",
          email: data?.email || "",
          phoneNumber: formattedPhoneNumber,
        }
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        setRecaptchaPaymentType('cardPointGooglePay');
        await chargeById({ paymentMethod: paymentMethod, customer }, cardPointGooglePayToken);
    };

    const chargeBySavedPaymentMethods = async (data) => {
      await chargeById({
          paymentMethod: data,
          customer: {
            name: updateCustomerRedux?.customerDetails?.name,
            email: updateCustomerRedux?.customerDetails?.email,
            phoneNumber: updateCustomerRedux?.customerDetails?.phoneNumber,
          }
      });
    };

    const chargeByIdSuccessActions = async (value) => {
        const { nextActionUrl, redirectUri } = value && value.subscription2Button;
        if (nextActionUrl) {
            window.location = nextActionUrl;
            return;
        }
        if (value?.paymentStatus === 'REQUIRE_CONFIRMATION') {
            setManualPlaidPayment(true);
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        const timeOut = value?.paymentStatus === 'REQUIRE_CONFIRMATION' ? 10000 : 5000;
        setTimeout(function () {
            const uri = getRedirectionUrl(hostName);
            if (redirectUri) {
                window.location = `${redirectUri}?sp-subscription-button=${subscriptionId}`;
            } else if (uri) {
                window.location = `${uri}pay-links/subscription-button/${subscriptionId}`;
            }
        }, timeOut);
        if (subscriptionId) { localStorage.removeItem(`${subscriptionId}-tap-index`) }
    };

    const chargeById = async (data, recaptchaToken = null) => {
        setTransactionModalOpen(true);
        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    }
                    if (encriptedData?.keyId) {
                        const value = await addSubscriptionButtonV2ChargeById(subscriptionId, payload);
                        if (!isPayPalGoogle.current) {
                            await chargeByIdSuccessActions(value);
                        }
                        return value;
                    }
                }
            }
        } catch (reason) {
            if (reason?.status === 429){
                setSavedPaymentDetails(data);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                return;
            }
            error(reason);
        }
    };

    const onGlobalCaptchaVerified = async (token) => {
        setRecaptchaModalVisible(false);
        switch (recaptchaPaymentType) {
            case TabNames.UPI:
                setPaymentLinkUpiGlobalRecaptcha(token);
                break;
            case 'paypalGooglePay':
                if (paypalPaymentData.current) {
                    chargeByPaypalGooglePay(paypalPaymentData.current, token);
                }
                break;
            case 'cardPointGooglePay':
                setCardPointGooglePayToken(token);
                break;
            case 'payPalButton':
                commonRecaptchaToken.current = token;
                break;
            default:
                await chargeById(savedPaymentDetails, token);
        }
        setRecaptchaPaymentType(null);
    }

    const onApprove = async (data) => {
        try {
            await confirmWalletOrderInfo(orderDatas?.paymentSessionGid, orderDatas?.psClientSecret);
            setTransactionSuccessModalOpen(true);
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const createOrder = async (paypalData, actions) => {
        try {
            const values = await getServerEncription(commonRecaptchaToken?.current ?? null);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    let data = {};
                    if (paypalData?.paymentSource === 'paypal') {
                        data = {
                            paymentMethodDetails: {
                                payPalWallet: {
                                    rawData: {
                                        experience_context: {
                                            payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                            landing_page: "LOGIN",
                                            return_url: SWIREPAY_URL,
                                            cancel_url: SWIREPAY_URL,
                                        }
                                    }
                                },
                                type: "WALLET",
                                subType: "PAYPAL_WALLET"
                            }
                        }
                    } else if (paypalData?.paymentSource === 'venmo') {
                        data = {
                            paymentMethodDetails: {
                                venmo: {
                                    rawData: {
                                        experience_context: {
                                            payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                            landing_page: "LOGIN",
                                            return_url: SWIREPAY_URL,
                                            cancel_url: SWIREPAY_URL,
                                        }
                                    }
                                },
                                type: "WALLET",
                                subType: "VENMO"
                            }
                        }
                    }
                    const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    }
                    if (encriptedData?.keyId) {
                        const value = await addSubscriptionButtonV2ChargeById(subscriptionId, payload);
                        commonRecaptchaToken.current = null;
                        if (value?.paymentSessionGid) {
                            setOrderData(value)
                            const orderData = await getWalletOrderInfo(value?.paymentSessionGid, value?.psClientSecret);
                            if (!orderData.id) {
                                const errorDetail = orderData.details[0];
                                const errorMessage = errorDetail
                                    ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                                    : "Unexpected error occurred, please try again.";

                                throw new Error(errorMessage);
                            }
                            return orderData?.id;
                        }
                    }
                }
            }
        } catch (error) {
            if (error?.status === 429) {
                setSavedPaymentDetails(paypalData);
                setRecaptchaPaymentType('payPalButton');
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                throw new Error('Recatpcha Required');
            }
            console.error(error);
            throw error || new Error('Unexpected error occurred, please try again.');
        }
    };

    const paymentTypes = useMemo(() => {
        if (!payment?.account?.defaultTestPaymentTypes
            || !payment?.account?.defaultTestRecurringPaymentTypes
            || !payment?.account?.supportedPaymentTypes
            || !payment?.account?.supportedRecurringPaymentTypes
            || typeof payment?.paymentMethodTypeEnabled !== 'boolean'
        ) return [TabNames.CARD];
        const defaultTestPaymentTypes = payment?.account?.defaultTestPaymentTypes;
        const defaultTestRecurringPaymentTypes = payment?.account?.defaultTestRecurringPaymentTypes || [];
        const supportedPaymentTypes = payment?.account?.supportedPaymentTypes;
        const supportedRecurringPaymentTypes = payment?.account?.supportedRecurringPaymentTypes;
        const allowedDefaultTestPaymentTypes = defaultTestPaymentTypes.filter(item => defaultTestRecurringPaymentTypes.includes(item));
        const allowedSupportedPaymentTypes = supportedPaymentTypes.filter(item => supportedRecurringPaymentTypes.includes(item));
        const expandedPaymentMethodTypes = expandCategoryToPaymentTypes(payment?.paymentMethodType);
        let types = [];
        // if test, then set the uniquePaymentTypes to the common types between defaultTestPaymentTypes and defaultTestRecurringPaymentTypes
        if (payment?.account?.portal?.test && !payment?.paymentMethodTypeEnabled) {
            types = allowedDefaultTestPaymentTypes;
        }
        // if test, and paymentMethodTypeEnabled is true then only show methods in both allowedDefaultTestPaymentTypes and paymentMethodType
        if (payment?.account?.portal?.test && payment?.paymentMethodTypeEnabled) {
            types = expandedPaymentMethodTypes?.filter(item => allowedDefaultTestPaymentTypes.includes(item)) ?? [];
        }
        // if live, then set the uniquePaymentTypes to the common types between supportedPaymentTypes and supportedRecurringPaymentTypes
        if (!payment?.account?.portal?.test && !payment?.paymentMethodTypeEnabled) {
            types = allowedSupportedPaymentTypes;
        }
        // if live, then set the uniquePaymentTypes to payment method type in both allowedSupportedPaymentTypes and paymentMethodType
        if (!payment?.account?.portal?.test && payment?.paymentMethodTypeEnabled) {
            types = expandedPaymentMethodTypes?.filter(item => allowedSupportedPaymentTypes.includes(item)) ?? [];
        }
        return types;
    }, [payment]);

    useEffect(() => {
        PayPalCheckoutEnable.current = paymentTypes.includes('PAYPAL_WALLET') || paymentTypes.includes('VENMO');
    }, [paymentTypes]);

    const uniquePaymentTypes = useMemo(() => getUniquePaymentTypes(paymentTypes), [paymentTypes]);

    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        let id;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerEnabled={true}
                headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                disableButtonText={disableButtonText}
                customerValidation={true}
                planStartDate={moment(payment && payment.plan2StartDate)}
                currentDateObject={moment(currentDateFormattedString)}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={subscriptionId}
                isManualPlaidNotSupport={true}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true} 
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={payment?.amount ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment?.currency && payment.currency.name)}` : null}
            />
            id = name;
        } else if (name === TabNames.ZIP_ACH) {
            children = <ZipAchPayment
                showCancelBtn={payment && payment.canDecline}
                headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With Zip ACH"}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={false}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                disableButtonText={disableButtonText}
                customerValidation={true}
                planStartDate={moment(payment && payment.plan2StartDate)}
                currentDateObject={moment(currentDateFormattedString)}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                paymentLinkId={subscriptionId}
                accountGid={payment?.account?.gid}
                isTest={payment?.account?.portal?.test}
                isManualPlaidNotSupport={true}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={payment?.amount ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment?.currency && payment.currency.name)}` : null}
                key="ZIP_ACH"
            />
            id = name;
        } else if (name === TabNames.RAPID_ACH) {
            children = <RapidAchPayment
                showCancelBtn={payment && payment.canDecline}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                disableButtonText={disableButtonText}
                customerValidation={true}
                planStartDate={moment(payment && payment.plan2StartDate)}
                currentDateObject={moment(currentDateFormattedString)}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                paymentLinkId={subscriptionId}
                accountGid={payment?.account?.gid}
                isTest={payment?.account?.portal?.test}
                isManualPlaidNotSupport={true}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={payment?.amount ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment?.currency && payment.currency.name)}` : null}
                key="RAPID_ACH"
            />
            id = name;
        } else if (name === TabNames.X_ACH) {
            children = <XAchPayment
                showCancelBtn={payment && payment.canDecline}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                disableButtonText={disableButtonText}
                customerValidation={true}
                planStartDate={moment(payment && payment.plan2StartDate)}
                currentDateObject={moment(currentDateFormattedString)}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                paymentLinkId={subscriptionId}
                accountGid={payment?.account?.gid}
                isTest={payment?.account?.portal?.test}
                isManualPlaidNotSupport={true}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={payment?.amount ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment?.currency && payment.currency.name)}` : null}
                key="X_ACH"
            />
            id = name;
        } else if (name === TabNames.INSTANT_ACH) {
            children = <InstantAch
                showCancelBtn={payment && payment.canDecline}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                disableButtonText={disableButtonText}
                customerValidation={true}
                planStartDate={moment(payment && payment.plan2StartDate)}
                currentDateObject={moment(currentDateFormattedString)}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                paymentLinkId={subscriptionId}
                accountGid={payment?.account?.gid}
                isTest={payment?.account?.portal?.test}
                isManualPlaidNotSupport={true}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={payment?.amount ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment?.currency && payment.currency.name)}` : null}
                key="X_ACH"
            />
            id = name;
        } else if (name === TabNames.SWIFT_ACH) {
            children = <SwiftAch
                showCancelBtn={payment && payment.canDecline}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                disableButtonText={disableButtonText}
                customerValidation={true}
                planStartDate={moment(payment && payment.plan2StartDate)}
                currentDateObject={moment(currentDateFormattedString)}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                paymentLinkId={subscriptionId}
                accountGid={payment?.account?.gid}
                isTest={payment?.account?.portal?.test}
                isManualPlaidNotSupport={true}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={payment?.amount ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment?.currency && payment.currency.name)}` : null}
                key="X_ACH"
            />
            id = name;
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                disableButtonText={disableButtonText}
                customerValidation={true}
                showAddress={true}
                planStartDate={moment(payment && payment.plan2StartDate)}
                currentDateObject={moment(currentDateFormattedString)}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                payments={payment}
            />
            id = name;
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                preFillCustomer={payment}
                headerText={"Pay With UPI"}
                buttonText={submitBtnText}
                customerValidation={true}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                supportedPaymentTypes={payment && payment.account && payment.account.supportedPaymentTypes}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
            id = name;
        } else if (name === TabNames.ACH) {
            children = <BankPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerDisabled={false}
                submit={chargeByBank}
                preFillCustomer={payment}
                headerText={"Pay With Bank Transfer"}
                buttonText={submitBtnText}
                paymentLinkId={subscriptionId}
                iavUrl={`${BASE_URLS.SUBSCRIPTION_BUTTON}/${subscriptionId}`}
                customerValidation={true}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
            id = name;
        } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <>
                {
                    payPalClientAuth ? (
                        <PayPalGooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByPaypalGooglePay}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            accountGid={payment?.account?.gid}
                            setTransactionModalOpen={setTransactionModalOpen}
                        />
                    ) : (
                        <GooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByGooglePay}
                            gpaySecretValues={gpaySecretValues}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                        />
                    )
                }
            </>
            id = name;
        } else if (name === TabNames.WALLET) {
            children = <>
                {
                    payPalClientAuth ? (
                        <PayPalGooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByPaypalGooglePay}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            accountGid={payment?.account?.gid}
                            setTransactionModalOpen={setTransactionModalOpen}
                        />
                    ) : (
                        <GooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByGooglePay}
                            gpaySecretValues={gpaySecretValues}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                        />
                    )
                }
            </>
            id = name;
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children, id });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                disableButtonText={disableButtonText}
                customerValidation={true}
                showAddress={true}
                planStartDate={moment(payment && payment.plan2StartDate)}
                currentDateObject={moment(currentDateFormattedString)}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                payments={payment}
            />,
            id: 'CARD'
        }
    ];

    if (payment?.account?.country?.alpha2 === 'US') {
      tabPanels.push({
        children: <SavedPaymentMethods
                    buttonText={submitBtnText}
                    submit={chargeBySavedPaymentMethods}
                    supportedPaymentTypes={uniquePaymentTypes}
                    accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                  />,
        id: 'SAVED_PAYMENT_METHODS'
      });
    }

    if (payPalClientAuth
        && payPalClientId
        && !tabPanels.map(item => item.id).includes('PAYPAL_METHOD')
        && (payment?.account?.supportedPaymentTypes?.includes('PAYPAL_WALLET') || payment?.account?.supportedPaymentTypes?.includes('VENMO'))
        && PayPalCheckoutEnable.current) {
      tabPanels.push({
          children: <div style={{ width: '200px'}} >
          <PayPalCheckout
          styles={{ shape: "rect", layout: "vertical" }}
          createOrder={createOrder}
          onApprove={onApprove}
          payPalClientId={payPalClientId}
          currency={payment?.account?.currency?.name || 'USD'}
          country={payment?.account?.country?.alpha2 || 'US'}
          accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
          />
          </div>,
          id: 'PAYPAL_METHOD',
      });
      if(!uniquePaymentTypes.includes('PAYPAL_METHOD')) uniquePaymentTypes.push('PAYPAL_METHOD');
    }

    return (
        <BaseSplitPage
        errorHeader={null}
        errorMsg={errorMessage}
        left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        {
                            (payment && payment.account && payment.account.largeLogo) && (
                                <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                            )
                        }
                        <H1Text>
                            Add Payment Method
                        </H1Text>
                        <H2Text>
                            Payment For
                        </H2Text>
                        <DescriptionText>
                            {payment && payment.plan2 && payment.plan2.name}
                        </DescriptionText>
                        <H2Text>
                            Amount Payable
                        </H2Text>
                        <DescriptionText fontSize="24px">
                            {payment ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}` : null}
                        </DescriptionText>
                        {
                            payment && payment.plan2StartDate && (
                                <>
                                    <H2Text>
                                        PLAN STARTS ON
                                    </H2Text>
                                    <DescriptionText>
                                        {getformatteddate(payment.plan2StartDate, (payment.account && payment.account.timezone))}
                                    </DescriptionText>
                                </>
                            )
                        }
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={payment && payment.support && payment.support.email}
                            phone={payment && payment.support && payment.support.phone}
                            partnerImageUrl={partnerImageUrl}
                            bankImageUrl={bankImageUrl}
                            whiteLabel={payment && payment.account && payment.account.whiteLabel}
                        />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header 
                    payment={payment} 
                    bankImageUrl={bankImageUrl}
                    cancelUrlLink={null} 
                />
                {payment?.account?.country?.alpha2 === 'US' ? (
                  <PaymentExpandableRowsV2
                    name={subscriptionId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={uniquePaymentTypes}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    accountGid={payment?.account?.gid}
                    supportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                    account={payment?.account}
                  />
                ) : (
                  <PaymentExpandableRows
                    name={subscriptionId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={uniquePaymentTypes}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    accountGid={payment?.account?.gid}
                  />
                )}
                <SmallScreenFooter
                    partnerImageUrl={partnerImageUrl}
                    bankImageUrl={bankImageUrl}
                    whiteLabel={payment && payment.account && payment.account.whiteLabel}
                />
                {/* {
                    payPalClientAuth && payPalClientId ? (
                        <>
                            <DescriptionText className="mb-3" fontSize="17px">PAY WITH PAYPAL</DescriptionText>
                            <PayPalCheckout
                                styles={{ shape: "rect", layout: "vertical" }}
                                createOrder={createOrder}
                                onApprove={onApprove}
                                payPalClientId={payPalClientId}
                                currency={payment?.account?.currency?.name || 'USD'}
                                country={payment?.account?.country?.alpha2 || 'US'}
                            />
                        </>
                    ) : (
                        <></>
                    )
                } */}
                <RecaptchaModal
                    visible={recaptchaModalVisible}
                    onVerified={onGlobalCaptchaVerified}
                />
                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                <SuccessModal isOpen={isTransactionSuccessModalOpen} manualPlaidPayment={manualPlaidPayment} />
                <Spinner isOpen={isShowSpinner} />
            </>
        } />
    )
};

export default SubscriptionButtonV2;
